export function createHeaderPlugin(): any {
    const tagName = 'HEADING';
    let plugin: any = {
        name: 'header',
        display: 'command',
        innerHTML: `<div className='header-button'>Header</div>`,
        buttonClass: 'header-button-wrapper',
        add: function (core: any, targetElement: any) {
            const context = core.context;
            const rangeTag = core.util.createElement(tagName);
            context[tagName] = {
                targetButton: targetElement,
                tag: rangeTag
            };
        },

        active(element: Element | null): boolean {
            const targetButton = this.context[tagName].targetButton;
            if (!element || element.nodeName !== tagName.toUpperCase()) {
                this.util.removeClass(targetButton, 'active');
                return false;
            }
            this.util.addClass(targetButton, 'active');
            return true;
        },

        action() {
            const targetButton = this.context[tagName].targetButton;
            if (!this.util.hasClass(targetButton, 'active')) {
                this.nodeChange(this.context[tagName].tag, null, null, null);
            } else {
                this.nodeChange(null, null, [tagName.toLowerCase()], null);
            }
        },
    }
    return plugin;
}